import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
	selector: 'page-ebook',
	templateUrl: 'ebook.html',
})


export class EbookPage {

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		private iab: InAppBrowser,) {
	}

	openEbook(){
		this.iab.create("http://ecomscotland.com/resources/ebook-5-steps-to-developing-effective-elearning/", '_system');
	}

}



// WEBPACK FOOTER //
// ./src/pages/ebook/ebook.ts